import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap'
import WriteEntry from './WriteEntry';
import JournalHistory from './JournalHistory';

function JournalEntries(props) {

    let [isLoading, setIsLoading] = useState(false);

    const onEntrySaved = async (entryText) => {
        setIsLoading(true);
        const query = `/api/journalEntry`;
        await fetch(query,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                cors: 'cors',
                body: JSON.stringify({
                    note: entryText,
                    petid: props.petId
                })
            });
        setIsLoading(false);
    }

    return (
        <React.Fragment>
            <Container fluid style={{ marginTop: 20 }}>
                <Row>
                    <Col>
                        <WriteEntry
                            shown={props.shown} 
                            isLoading={isLoading} 
                            onEntrySaved={onEntrySaved} />
                    </Col>
                </Row>
            </Container>
            <Container fluid>
                <Row>
                    <Col>
                        <JournalHistory 
                            shown={props.shown}
                            reloadData={isLoading} 
                            petId={props.petId} />
                    </Col>
                </Row>
            </Container>
        </React.Fragment>
    );

}

export default JournalEntries;